
import React, { useState } from 'react';
import { CheckCircle2, AlertCircle, X } from 'lucide-react';
import { SaveDialogProps } from './types';

const SaveDialog: React.FC<SaveDialogProps> = ({ open, onClose, onSubmit, saving }) => {
  const [reason, setReason] = useState('Configuration Update');
  const [message, setMessage] = useState('');

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={onClose}></div>
      
      {/* Dialog */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200 border border-slate-200">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2">
              <CheckCircle2 className="text-teal-500" />
              Save Group Hierarchy
            </h3>
            <button onClick={onClose} className="p-1 text-slate-400 hover:bg-slate-100 rounded-full transition-colors">
              <X size={20} />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Reason for Change</label>
              <select 
                className="w-full p-2.5 text-sm border border-slate-300 rounded-lg focus:ring-1 focus:ring-teal-500/20 focus:border-teal-500 focus:outline-none bg-white text-slate-700"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              >
                <option>Configuration Update</option>
                <option>New Group Structure</option>
                <option>Refactor / Hierarchy Change</option>
                <option>Emergency Fix</option>
                <option>Other</option>
              </select>
            </div>

            <div>
              <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Detailed Message</label>
              <textarea
                className="w-full p-2.5 text-sm border border-slate-300 rounded-lg h-32 focus:ring-1 focus:ring-teal-500/20 focus:border-teal-500 focus:outline-none resize-none text-slate-700 placeholder-slate-400"
                placeholder="Describe the changes made to the group hierarchy..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
          </div>

          <div className="mt-8 flex gap-3">
            <button 
              onClick={onClose}
              className="flex-1 py-2.5 px-4 border border-slate-300 text-slate-600 font-bold text-sm rounded-xl hover:bg-slate-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => onSubmit(reason, message)}
              disabled={saving || !reason}
              className={`flex-1 py-2.5 px-4 bg-teal-600 text-white font-bold text-sm rounded-xl transition-all shadow-lg shadow-teal-600/20 ${
                saving ? 'opacity-50 cursor-not-allowed' : 'hover:bg-teal-700 active:scale-95'
              }`}
            >
              {saving ? 'Saving...' : 'Confirm Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveDialog;
